import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useAppDispatch } from '@/redux/hooks'
import { setRoomHandUpStatus } from '@/redux/reducers/socket'

// Components
import Icon from '@/assets/icons'
import Button from '@/components/common/Button'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)
interface RoomHandUpParams {
  dispatch: any
  canHandUp: boolean
}

const Invite = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const handleRoomHandUpChange = ({ canHandUp }: RoomHandUpParams) => {
    dispatch(setRoomHandUpStatus({ canHandUp }))
  }

  return (
    <div className={cx('invite')}>
      <div className={cx('invite-icon')}>
        <Icon.Mic />
      </div>

      <p className={cx('invite-title')}>{t('LiveRoom_Invite_Title')}</p>
      <p className={cx('invite-description')}>{t('LiveRoom_Invite_Description')}</p>

      <Button size='sm' onClick={() => handleRoomHandUpChange({ dispatch, canHandUp: true })}>
        {t('LiveRoom_Invite_Button')}
      </Button>
    </div>
  )
}

export default Invite
